/** Utah's words for houserules.ts: the food handler card law, Utah Code 26B-7-413. */
export const HOUSERULES_UT = {
  /** The statute that sets the food handler card deadline (subsections (2) and (5)(b)). */
  cardCitation: "Utah Code 26B-7-413(2), (5)(b)",
  /** The line shown to the person: the card is due within 30 days of hire. */
  cardLine: "Food handler permit needed within 30 days of hire (Utah Code 26B-7-413).",
  /** Days after hire by which the card is due (26B-7-413(5)(b)). */
  cardDays: 30,
} as const;
